import { render } from "./TotalBalance.vue?vue&type=template&id=27bf785a&ts=true"
import script from "./TotalBalance.vue?vue&type=script&lang=ts"
export * from "./TotalBalance.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__